function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/* eslint-disable import/prefer-default-export */ import { ACCEPT_INVITATION_FAILURE, ACCEPT_INVITATION_SUCCESS, CREATE_INVITATION_SUCCESS, CREATE_INVITATION_SUCCESS_RESET, DEACTIVATE_USER_SUCCESS, FETCH_USER_DETAILS_FAILURE, FETCH_USER_DETAILS_SUCCESS, GET_DEACTIVATED_USERS_FAILURE, GET_DEACTIVATED_USERS_SUCCESS, GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS, GET_USERS_FOR_LOGISTICS_PARTY_FAILURE, GET_USERS_FOR_LOGISTICS_PARTY_REQUEST, GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS, GET_USER_PROFILE_INFO_ACTIONS_SUCCESS, UPDATE_USER_LOCALE_SUCCESS, UPDATE_USER_PROFILE_INFO_SUCCESS } from "../../actions/userManagementActions/actionTypes";
export var initialState = {
    user: {},
    invitationStatus: {
        status: "",
        error: false
    },
    requestedUserProfileDetails: {},
    usersList: [],
    usersListError: false,
    invitationsList: [],
    createInvitationSuccess: false,
    deactivatedUsersList: null
};
export function userManagementReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, ref2 = arguments.length > 1 ? arguments[1] : void 0, type = ref2.type, payload = ref2.payload;
    switch(type){
        case GET_USER_PROFILE_INFO_ACTIONS_SUCCESS:
            {
                return _objectSpread({}, state, {
                    user: payload.user
                });
            }
        case UPDATE_USER_PROFILE_INFO_SUCCESS:
        case UPDATE_USER_LOCALE_SUCCESS:
            {
                return _objectSpread({}, state, {
                    user: payload
                });
            }
        case ACCEPT_INVITATION_SUCCESS:
            {
                return _objectSpread({}, state, {
                    invitationStatus: {
                        status: payload,
                        error: false
                    }
                });
            }
        case ACCEPT_INVITATION_FAILURE:
            {
                return _objectSpread({}, state, {
                    invitationStatus: {
                        status: "",
                        error: true
                    }
                });
            }
        case GET_USERS_FOR_LOGISTICS_PARTY_REQUEST:
            {
                return _objectSpread({}, state, {
                    usersListError: false
                });
            }
        case GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS:
            {
                return _objectSpread({}, state, {
                    usersList: payload || []
                });
            }
        case GET_USERS_FOR_LOGISTICS_PARTY_FAILURE:
            {
                return _objectSpread({}, state, {
                    usersListError: true
                });
            }
        case GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS:
            {
                var ref1;
                return _objectSpread({}, state, {
                    invitationsList: (payload === null || payload === void 0 ? void 0 : payload.length) ? payload.map(function(invitation) {
                        var ref;
                        return _objectSpread({}, invitation, {
                            inviteeEmail: (ref1 = invitation === null || invitation === void 0 ? void 0 : (ref = invitation.invitationChannelInfo) === null || ref === void 0 ? void 0 : ref.inviteeEmail) !== null && ref1 !== void 0 ? ref1 : ""
                        });
                    }) : []
                });
            }
        case CREATE_INVITATION_SUCCESS:
            {
                return _objectSpread({}, state, {
                    createInvitationSuccess: true
                });
            }
        case CREATE_INVITATION_SUCCESS_RESET:
            {
                return _objectSpread({}, state, {
                    createInvitationSuccess: false
                });
            }
        case DEACTIVATE_USER_SUCCESS:
            {
                return _objectSpread({}, state, {
                    deactivatedUsersList: null,
                    usersList: null
                });
            }
        case GET_DEACTIVATED_USERS_SUCCESS:
            {
                return _objectSpread({}, state, {
                    deactivatedUsersList: payload.userList
                });
            }
        case GET_DEACTIVATED_USERS_FAILURE:
            {
                return _objectSpread({}, state, {
                    deactivatedUsersList: undefined
                });
            }
        case FETCH_USER_DETAILS_SUCCESS:
            {
                var requestedUserId = payload.requestedUserId, requestedUserDetails = payload.requestedUserDetails;
                return _objectSpread({}, state, {
                    requestedUserProfileDetails: _objectSpread({}, state.requestedUserProfileDetails, _defineProperty({}, requestedUserId, requestedUserDetails))
                });
            }
        case FETCH_USER_DETAILS_FAILURE:
            {
                var requestedUserId1 = payload.requestedUserId;
                return _objectSpread({}, state, {
                    requestedUserProfileDetails: _objectSpread({}, state.requestedUserProfileDetails, _defineProperty({}, requestedUserId1, {}))
                });
            }
        default:
            {
                return state;
            }
    }
}

//# sourceMappingURL=index.js.map